import baseClient from './baseClient';

const getHomepageStats = async () => {
    return baseClient.get('stats');
}

const getAdmin = async () => {
    return baseClient.get('club');
}

const getAdminForAdminPage = async () => {
    return baseClient.get('admin/for-admin');
}

const updateAdmin = async ({
    introText,
    primaryColor,
    seasonStart,
    transferWindow,
    canEdit,
    gameweekAdvanceDay,
    gameweekAdvanceTime,
    autoPriceChange,
    transferDeduct
}) => {
    return baseClient.patch(
        'admin/update',
        {
            introText: introText,
            primaryColor: primaryColor,
            seasonStart: seasonStart,
            transferWindow: transferWindow,
            canEdit: canEdit,
            gameweekAdvanceDay: gameweekAdvanceDay,
            gameweekAdvanceTime: gameweekAdvanceTime,
            autoPriceChange: autoPriceChange,
            transferDeduct: transferDeduct
        }
    );
}

const getImportedMatches = async () => {
    return baseClient.get('match/imported-matches');
}

const updateMatch = async (matchId, importMatch) => {
    return baseClient.patch(
        `match/${matchId}`,
        {
            import: importMatch
        }
    );
}

const importMatch = async (matchId, gameweek) => {
    return baseClient.post(
        'match/import',
        {
            gameweek: gameweek,
            matchId: matchId
        }
    );
}

const deleteMatch = async (matchId) => {
    return baseClient.delete(`match/${matchId}`);
}

const reImportMatch = async (matchPcId) => {
    return baseClient.get(`match/reimport/${matchPcId}`);
}

const getUsers = async () => {
    return baseClient.get('admin/users');
}

const updateUser = async (userId, userInfo) => {
    return baseClient.patch(`admin/update-user/${userId}`, userInfo);
}

const addPointsDeduction = async (postData) => {
    return baseClient.post('deduction/add', postData);
}

const deletePointsDeduction = async (deductionId) => {
    return baseClient.delete(`deduction/${deductionId}`);
}

const getPlayersToImport = ({forceRefetch}) => {
    return baseClient.get(
        'match/import-players',
        { params: { forceRefetch } }
    );
}

const getMatchesWithoutPlayer = async (playerId) => {
    return baseClient.get(`match/without-player/${playerId}`);
}

const uploadLogo = async ({logo}) => {
    return baseClient.post('admin/upload-logo', { logo });
}

const deleteLogo = async () => {
    return baseClient.delete('admin/delete-logo');
}

const updatePointsStructure = async (pointsStructure) => {
    return baseClient.patch('points/structure', { positions: pointsStructure });
}

const getEntryFundsSummary = async () => {
    return baseClient.get('admin/entry-payment-summary');
}

const addImportMatchRule = async ({weekday, matchType}) => {
    return baseClient.post('match/add-import-rule', { weekday, matchType });
}

const getMatchImportRules = async () => {
    return baseClient.get('match/import-rules');
}

const deleteMatchImportRule = async ({matchImportRuleId}) => {
    return baseClient.delete(`match/import-rule/${matchImportRuleId}`);
}

const getMatchData = async ({matchId}) => {
    return baseClient.get(`match/${matchId}`);
}

const getLatestMatchesWithPlayers = async () => {
    return baseClient.get('match/latest-with-players');
}

const clearCache = async () => {
    return baseClient.post('admin/clear-cache', {});
}

const endSeason = async () => {
    return baseClient.post('admin/end-season', {});
}

const importManualMatch = async ({
    playerData,
    homeTeam,
    awayTeam,
    matchDate,
    matchType,
    gameweek,
    matchId = null,
    matchResult
}) => {
    return baseClient.post(
        'match/import/manual',
        {
            playerData,
            homeTeam,
            awayTeam,
            matchDate,
            matchType,
            gameweek,
            matchId,
            matchResult
        }
    );
}

const assignPlayerToMatchData = async (playerAndGamePlayerData) => {
    return baseClient.put(
        'match/assign-players-to-data',
        {
            updates: playerAndGamePlayerData
        }
    );
}
export {
    getHomepageStats,
    getAdmin,
    updateAdmin,
    getAdminForAdminPage,
    getImportedMatches,
    updateMatch,
    importMatch,
    deleteMatch,
    reImportMatch,
    getUsers,
    updateUser,
    getPlayersToImport,
    getMatchesWithoutPlayer,
    uploadLogo,
    deleteLogo,
    addPointsDeduction,
    deletePointsDeduction,
    updatePointsStructure,
    getEntryFundsSummary,
    addImportMatchRule,
    getMatchImportRules,
    deleteMatchImportRule,
    getMatchData,
    clearCache,
    importManualMatch,
    assignPlayerToMatchData,
    endSeason,
    getLatestMatchesWithPlayers
}
